import React from 'react';
import { useTheme, getThemeClasses } from '../context/ThemeContext';

export default function BackgroundDecoration() {
  const { theme } = useTheme();
  const themeClasses = getThemeClasses(theme);
  
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Sparkles */}
      <div className="absolute w-2 h-2 rounded-full bg-white/30 animate-float" style={{ top: '10%', left: '20%' }} />
      <div className="absolute w-2 h-2 rounded-full bg-white/30 animate-float" style={{ top: '30%', left: '80%', animationDelay: '1s' }} />
      <div className="absolute w-2 h-2 rounded-full bg-white/30 animate-float" style={{ top: '70%', left: '15%', animationDelay: '2s' }} />
      <div className="absolute w-2 h-2 rounded-full bg-white/30 animate-float" style={{ top: '40%', left: '60%', animationDelay: '3s' }} />
      <div className="absolute w-2 h-2 rounded-full bg-white/30 animate-float" style={{ top: '85%', left: '75%', animationDelay: '4s' }} />
      
      {/* Flowers */}
      <img 
        src="https://images.pexels.com/photos/5858235/pexels-photo-5858235.jpeg?auto=compress&cs=tinysrgb&w=300" 
        className="absolute -right-20 top-0 w-40 h-40 object-cover opacity-20 rotate-45 animate-float"
        alt=""
        style={{ animationDelay: '1s' }}
      />
      <img 
        src="https://images.pexels.com/photos/5858235/pexels-photo-5858235.jpeg?auto=compress&cs=tinysrgb&w=300" 
        className="absolute -left-20 bottom-0 w-40 h-40 object-cover opacity-20 -rotate-45 animate-float"
        alt=""
        style={{ animationDelay: '2s' }}
      />
    </div>
  );
}